export default "__VITE_ASSET__BxnV2PSe__";